import { ParentProps } from "solid-js";
import { requireSelectContext } from "../SelectContext";
import { GroupDef } from "../SelectContext";

export function SelectGroup(props: ParentProps<{ label: string; }>) {
    const ctx = requireSelectContext();
    const groupDef = new GroupDef(props.label);

    ctx.setGroups([...ctx.groups(), groupDef]);
    return <>
        {props.children}
    </>
}
